<div class="bottom-sheet-container" [class.bottom-sheet-container--closable]="!!closeButtonLabel || !!backButtonLabel" #bottomSheetContainer>
  <div class="bottom-sheet-drag-handle" aria-label="Drag handle" role="button">
    <span class="bottom-sheet-drag-pill"></span>
  </div>
  <button *ngIf="backButtonLabel" pButton type="button" icon="pi pi-arrow-left"
    class="bottom-sheet-back-button p-button-text p-button-plain p-button-rounded p-button-icon-only"
    [attr.aria-label]="backButtonLabel" (click)="backButtonClick.emit()"></button>
  <button *ngIf="closeButtonLabel" pButton type="button" icon="pi pi-times"
    class="bottom-sheet-close-button p-button-text p-button-plain p-button-rounded p-button-icon-only"
    [attr.aria-label]="closeButtonLabel" (click)="closeIfPresented()"></button>
  <div class="bottom-sheet-content">
    <ng-content></ng-content>
  </div>
</div>
